import { observable, reaction } from 'mobx';
import { autobind } from 'core-decorators';
import { useEffect } from 'react';
import { BUTTONS } from './config';
import FooterStore from './components/footer/store';

class BackTopFooterStore {
  footerStore = new FooterStore({
    onBackTop: this.backTop
  });

  @observable isShowBackTop = false;
  @observable onBackTop = null;
  @observable isActive = false;
  @observable btns = BUTTONS;

  @observable backTopIcon = require('@src/business-components/backtop-footer/images/btn-back-top-layer-1.png');
  @observable scrollDownIcon = require('@src/business-components/backtop-footer/images/btn-back-top-layer-1.png');
  @observable beforeBg = require('@src/business-components/backtop-footer/images/light.png');
  @observable afterBg = require('@src/business-components/backtop-footer/images/footer-bg-light.png');
  @observable copyrightBorder = require('@src/business-components/backtop-footer/images/copyright.png');
  @observable copyrightColor = '#04ccd3';

  constructor(options = {}) {
    Object.assign(this, options);
  }

  @autobind
  backTop() {
    if (!this.onBackTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.onBackTop();
    }
    this.isActive = false;
  }

  @autobind
  toggleCRFooterVisible() {
    this.isActive = !this.isActive;
  }

  use() {
    useEffect(() => {
      if (!this.onBackTop) {
        const handleScroll = () => {
          this.isShowBackTop = window.scrollY > 0;
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }
    }, []);

    useEffect(() => {
      reaction(
        () => this.isShowBackTop,
        isShow => {
          this.footerStore.isShowBackTop = isShow;
        }
      );
    }, []);
  }
}

export default BackTopFooterStore;
